import React, { useState, useEffect } from 'react';
import { Card, CardHeader } from '../components/UI';
import { api } from '../api';

function formatCurrency(val) {
  const num = val.replace(/[^0-9.]/g, '');
  if (!num) return '';
  return '$' + parseFloat(num).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

export default function Policies() {
  const [policies, setPolicies] = useState([]);
  const [leads, setLeads] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [form, setForm] = useState({ lead_name: "", lead_id: "", lead_email: "", policy_type: "", premium: "", carrier: "", effective_date: "", deductible: "" });
  const [quoteForm, setQuoteForm] = useState({ lead_name: "", lead_id: "", carrier: "", premium: "", quote_type: "", notes: "" });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [savingQuote, setSavingQuote] = useState(false);
  const [savedQuote, setSavedQuote] = useState(false);
  const [tab, setTab] = useState('policy');

  const load = () => api.getPolicies().then(setPolicies).catch(() => {});

  useEffect(() => {
    load();
    api.getLeads().then(setLeads).catch(() => {});
    api.getTemplates().then(data => setTemplates(data || [])).catch(() => {});
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const handleLeadSelect = (e) => {
    const lead = leads.find(l => (l._id || l.id) === e.target.value);
    if (lead) setForm(f => ({ ...f, lead_name: lead.name, lead_id: lead._id || lead.id, lead_email: lead.email || '' }));
  };

  const handleQuoteLeadSelect = (e) => {
    const lead = leads.find(l => (l._id || l.id) === e.target.value);
    if (lead) setQuoteForm(f => ({ ...f, lead_name: lead.name, lead_id: lead._id || lead.id }));
  };

  const handleSave = async () => {
    if (!form.lead_name || !form.policy_type) return;
    setSaving(true);
    try {
      await api.createPolicy(form);
      const template = templates.find(t => t.policy_type === form.policy_type);
      if (template && form.lead_email) {
        try { await api.sendPolicyBreakdown({ ...form, email: form.lead_email, template }); } catch (e) {}
      }
      await load();
      setSaved(true); setTimeout(() => setSaved(false), 3000);
      setForm({ lead_name: "", lead_id: "", lead_email: "", policy_type: "", premium: "", carrier: "", effective_date: "", deductible: "" });
    } catch (err) { alert(err.message); }
    setSaving(false);
  };

  const handleSaveQuote = async () => {
    if (!quoteForm.lead_name) return;
    setSavingQuote(true);
    try {
      await api.createPolicy({ ...quoteForm, policy_type: 'Quote', status: 'quote' });
      await load();
      setSavedQuote(true); setTimeout(() => setSavedQuote(false), 3000);
      setQuoteForm({ lead_name: "", lead_id: "", carrier: "", premium: "", quote_type: "", notes: "" });
    } catch (err) { alert(err.message); }
    setSavingQuote(false);
  };

  const policiesSold = policies.filter(p => p.policy_type !== 'Quote');
  const quotesSent = policies.filter(p => p.policy_type === 'Quote');

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16, maxWidth: 680 }}>

      {/* Tab switcher */}
      <div style={{ display: "flex", gap: 4, padding: 4, background: "var(--bg3)", borderRadius: 10, width: "fit-content", border: "0.5px solid var(--border)" }}>
        {[{ id: 'policy', label: '⚡ Log a policy' }, { id: 'quote', label: '📋 Log a quote' }].map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{ padding: "7px 22px", borderRadius: 8, border: "none", background: tab === t.id ? "linear-gradient(135deg,#534AB7,#1D9E75)" : "transparent", color: tab === t.id ? "#fff" : "var(--text2)", fontSize: 13, fontWeight: tab === t.id ? 600 : 400, cursor: "pointer", transition: "all 0.2s" }}>
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'policy' && (
        <div style={{ background: "var(--bg2)", borderRadius: 16, border: "0.5px solid rgba(83,74,183,0.3)", overflow: "hidden", boxShadow: "0 0 30px rgba(83,74,183,0.08)" }}>
          <div style={{ padding: "14px 20px", borderBottom: "0.5px solid var(--border)", background: "linear-gradient(135deg,rgba(83,74,183,0.08),rgba(29,158,117,0.06))", display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#534AB7", boxShadow: "0 0 8px #534AB7" }} />
            <span style={{ fontSize: 13, fontWeight: 700, color: "var(--text)", letterSpacing: "-0.3px" }}>Log a sold policy</span>
          </div>
          <div style={{ padding: "20px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <div style={{ gridColumn: "1/-1" }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Client name *</div>
              <select onChange={handleLeadSelect} defaultValue="" style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg3)", fontSize: 12, color: "var(--text)", cursor: "pointer" }}>
                <option value="">Select a client...</option>
                {leads.map(l => <option key={l._id || l.id} value={l._id || l.id}>{l.name}</option>)}
              </select>
              {form.lead_name && <div style={{ marginTop: 5, fontSize: 11, color: "#1D9E75" }}>✓ {form.lead_name}</div>}
            </div>
            <div style={{ gridColumn: "1/-1" }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Client email</div>
              <input value={form.lead_email} onChange={e => setForm(f => ({ ...f, lead_email: e.target.value }))} placeholder="client@email.com" style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg3)", fontSize: 12, color: "var(--text)", boxSizing: "border-box" }} />
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Policy type *</div>
              <select value={form.policy_type} onChange={e => setForm(f => ({ ...f, policy_type: e.target.value }))} style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg3)", fontSize: 12, color: "var(--text)", cursor: "pointer" }}>
                <option value="">Select type...</option>
                {templates.map(t => <option key={t._id || t.policy_type} value={t.policy_type}>{t.policy_type}</option>)}
              </select>
              {templates.length === 0 && <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 4 }}>Create templates in the Templates tab first.</div>}
              {form.policy_type && templates.find(t => t.policy_type === form.policy_type) && (
                <div style={{ fontSize: 11, color: "#1D9E75", marginTop: 4 }}>✓ Will send "{templates.find(t => t.policy_type === form.policy_type)?.subject}"</div>
              )}
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Insurance carrier</div>
              <input value={form.carrier} onChange={e => setForm(f => ({ ...f, carrier: e.target.value }))} style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg3)", fontSize: 12, color: "var(--text)", boxSizing: "border-box" }} />
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Monthly premium</div>
              <input value={form.premium} onChange={e => setForm(f => ({ ...f, premium: formatCurrency(e.target.value) }))} placeholder="$0" style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg3)", fontSize: 12, color: "var(--text)", boxSizing: "border-box" }} />
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Deductible</div>
              <input value={form.deductible} onChange={e => setForm(f => ({ ...f, deductible: formatCurrency(e.target.value) }))} placeholder="$0" style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg3)", fontSize: 12, color: "var(--text)", boxSizing: "border-box" }} />
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Effective date</div>
              <input type="date" value={form.effective_date} onChange={e => setForm(f => ({ ...f, effective_date: e.target.value }))} style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg3)", fontSize: 12, color: "var(--text)", boxSizing: "border-box" }} />
            </div>
            <div style={{ gridColumn: "1/-1", display: "flex", gap: 10, alignItems: "center", paddingTop: 4 }}>
              <button onClick={handleSave} disabled={saving} style={{ padding: "10px 28px", borderRadius: 8, border: "none", background: "linear-gradient(135deg,#534AB7,#1D9E75)", color: "#fff", fontSize: 13, fontWeight: 600, cursor: saving ? "not-allowed" : "pointer", display: "flex", alignItems: "center", gap: 8, boxShadow: "0 4px 15px rgba(83,74,183,0.3)" }}>
                <i className="ti ti-send" aria-hidden="true" />
                {form.policy_type && form.lead_email ? "Send welcome email" : "Send policy"}
              </button>
              {saved && <span style={{ fontSize: 12, color: "#1D9E75" }}>✓ Saved!</span>}
            </div>
          </div>
        </div>
      )}

      {tab === 'quote' && (
        <div style={{ background: "var(--bg2)", borderRadius: 16, border: "0.5px solid rgba(29,158,117,0.3)", overflow: "hidden", boxShadow: "0 0 30px rgba(29,158,117,0.06)" }}>
          <div style={{ padding: "14px 20px", borderBottom: "0.5px solid var(--border)", background: "linear-gradient(135deg,rgba(29,158,117,0.08),rgba(83,74,183,0.06))", display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#1D9E75", boxShadow: "0 0 8px #1D9E75" }} />
            <span style={{ fontSize: 13, fontWeight: 700, color: "var(--text)", letterSpacing: "-0.3px" }}>Log a quote sent</span>
          </div>
          <div style={{ padding: "20px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <div style={{ gridColumn: "1/-1" }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Client name *</div>
              <select onChange={handleQuoteLeadSelect} defaultValue="" style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg3)", fontSize: 12, color: "var(--text)", cursor: "pointer" }}>
                <option value="">Select a client...</option>
                {leads.map(l => <option key={l._id || l.id} value={l._id || l.id}>{l.name}</option>)}
              </select>
              {quoteForm.lead_name && <div style={{ marginTop: 5, fontSize: 11, color: "#1D9E75" }}>✓ {quoteForm.lead_name}</div>}
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Carrier</div>
              <input value={quoteForm.carrier} onChange={e => setQuoteForm(f => ({ ...f, carrier: e.target.value }))} style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg3)", fontSize: 12, color: "var(--text)", boxSizing: "border-box" }} />
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Quoted premium</div>
              <input value={quoteForm.premium} onChange={e => setQuoteForm(f => ({ ...f, premium: formatCurrency(e.target.value) }))} placeholder="$0" style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg3)", fontSize: 12, color: "var(--text)", boxSizing: "border-box" }} />
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Quote type</div>
              <select value={quoteForm.quote_type || ""} onChange={e => setQuoteForm(f => ({ ...f, quote_type: e.target.value }))} style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg3)", fontSize: 12, color: "var(--text)", cursor: "pointer" }}>
                <option value="">Select type...</option>
                {templates.map(t => <option key={t._id || t.policy_type} value={t.policy_type}>{t.policy_type}</option>)}
              </select>
              {templates.length === 0 && <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 4 }}>Create templates in the Templates tab first.</div>}
            </div>
            <div style={{ gridColumn: "1/-1" }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Notes</div>
              <input value={quoteForm.notes} onChange={e => setQuoteForm(f => ({ ...f, notes: e.target.value }))} style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg3)", fontSize: 12, color: "var(--text)", boxSizing: "border-box" }} />
            </div>
            <div style={{ gridColumn: "1/-1", display: "flex", gap: 10, alignItems: "center", paddingTop: 4 }}>
              <button onClick={handleSaveQuote} disabled={savingQuote} style={{ padding: "10px 28px", borderRadius: 8, border: "none", background: "linear-gradient(135deg,#1D9E75,#534AB7)", color: "#fff", fontSize: 13, fontWeight: 600, cursor: savingQuote ? "not-allowed" : "pointer", display: "flex", alignItems: "center", gap: 8, boxShadow: "0 4px 15px rgba(29,158,117,0.3)" }}>
                <i className="ti ti-send" aria-hidden="true" />Send quote
              </button>
              {savedQuote && <span style={{ fontSize: 12, color: "#1D9E75" }}>✓ Saved!</span>}
            </div>
          </div>
        </div>
      )}

      {/* Welcome emails sent */}
      <div style={{ background: "var(--bg2)", borderRadius: 16, border: "0.5px solid var(--border)", overflow: "hidden" }}>
        <div style={{ padding: "12px 20px", borderBottom: "0.5px solid var(--border)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#534AB7" }} />
            <span style={{ fontSize: 13, fontWeight: 700, color: "var(--text)" }}>Welcome emails sent</span>
          </div>
          <span style={{ fontSize: 12, fontWeight: 700, color: "#534AB7", background: "rgba(83,74,183,0.1)", padding: "2px 10px", borderRadius: 20 }}>{policiesSold.length}</span>
        </div>
        {policiesSold.length === 0 && <div style={{ padding: "24px 16px", textAlign: "center", color: "var(--text3)", fontSize: 13 }}>No policies logged yet</div>}
        {policiesSold.map(p => (
          <div key={p._id || p.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 20px", borderBottom: "0.5px solid var(--border)" }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text)" }}>{p.lead_name}</div>
              <div style={{ fontSize: 11, color: "var(--text2)", marginTop: 2 }}>{p.policy_type} · {p.carrier || "—"} · {p.premium || "—"}{p.deductible ? " · Ded: " + p.deductible : ""}</div>
            </div>
            <span style={{ fontSize: 11, color: "var(--text3)" }}>{p.created_at ? new Date(p.created_at).toLocaleDateString() : "—"}</span>
          </div>
        ))}
      </div>

      {/* Quotes sent */}
      <div style={{ background: "var(--bg2)", borderRadius: 16, border: "0.5px solid var(--border)", overflow: "hidden" }}>
        <div style={{ padding: "12px 20px", borderBottom: "0.5px solid var(--border)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#1D9E75" }} />
            <span style={{ fontSize: 13, fontWeight: 700, color: "var(--text)" }}>Quotes sent</span>
          </div>
          <span style={{ fontSize: 12, fontWeight: 700, color: "#1D9E75", background: "rgba(29,158,117,0.1)", padding: "2px 10px", borderRadius: 20 }}>{quotesSent.length}</span>
        </div>
        {quotesSent.length === 0 && <div style={{ padding: "24px 16px", textAlign: "center", color: "var(--text3)", fontSize: 13 }}>No quotes logged yet</div>}
        {quotesSent.map(p => (
          <div key={p._id || p.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 20px", borderBottom: "0.5px solid var(--border)" }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text)" }}>{p.lead_name}</div>
              <div style={{ fontSize: 11, color: "var(--text2)", marginTop: 2 }}>{p.carrier || "—"} · {p.premium || "—"}{p.notes ? " · " + p.notes : ""}</div>
            </div>
            <span style={{ fontSize: 11, color: "var(--text3)" }}>{p.created_at ? new Date(p.created_at).toLocaleDateString() : "—"}</span>
          </div>
        ))}
      </div>

    </div>
  );
}